module.exports = {
    // 联盟战状态变化
    UpdateGuildWarStatusEvent: "UpdateGuildWarStatusEvent",

    // 联盟战详细数据
    GuildWarEnemyPositionDataInitEvent: "GuildWarEnemyPositionDataInitEvent",

    // 挑战次数更新
    UpdateGuildwarChallengeCountEvent: "UpdateGuildwarChallengeCountEvent",

    // 据点数据更新
    UpdateGuildWarPositionDataEvent: "UpdateGuildWarPositionDataEvent",

    // 基础数据更新（星数、buff）
    UpdateGuildWarBaseInfoEvent: "UpdateGuildWarBaseInfoEvent",

    // 我方联盟据点数据
    GetGuildWarMyPositionDataEvent: "GetGuildWarMyPositionDataEvent",

    // 排行榜数据
    UpdateGuildWarRankDataEvent: "UpdateGuildWarRankDataEvent",

    // 联盟战主界面红点更新
    UpdateGuildWarRedStatusEvent: "UpdateGuildWarRedStatusEvent",

    // 奖励宝箱数据更新
    UpdateGuildWarBoxDataEvent: "UpdateGuildWarBoxDataEvent",

    // 单个宝箱数据更新
    UpdateSingleBoxDataEvent: "UpdateSingleBoxDataEvent",

    // 更新我的宝箱领取状态
    UpdateMyAwardBoxEvent: "UpdateMyAwardBoxEvent",

}